import Button from "components/Button";
import styles from "./style.module.scss";
import { translations } from "i18n";
import disconnectedDevicesImg from "../../images/devices/disconnected-devices.png";
import { IoCloseOutline } from "react-icons/io5";

export const DisconnectedDevicesModal = ({ setShowModal }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.modalWrapper} id="modalWrapper">
        <img src={disconnectedDevicesImg} alt="disconnected devices" />
        <div className={styles.modalTitle}>
          <span>{translations("DisconnectedModal.Title")}</span>
        </div>
        <span className={styles.modalDescription}>
          {translations("DisconnectedModal.Description")}
        </span>
        <Button
          text={"Reload"}
          onClick={() => window.location.reload()}
          classnames={styles.modalButton}
        />
        <IoCloseOutline
          color="#9ea7b4"
          className={styles.closeIcon}
          onClick={() => setShowModal(false)}
        />
      </div>
    </div>
  );
};

export default DisconnectedDevicesModal;
